<template>
	<div class="d-flex h-100">
		<div class="bg-darker text-uppercase">
			<a href="#tab=efficiency" class="d-block border-bottom border-dark p-4 px-5 text-decoration-none"
				@click.prevent="tab = 'efficiency'" :class="[tab == 'efficiency' ? 'bg-white' : 'text-orange']">
				Efficiency</a>
			<a href="#tab=compliance" class="d-block border-bottom border-dark p-4 px-5 text-decoration-none"
				@click.prevent="tab = 'compliance'"
				:class="[tab == 'compliance' ? 'bg-white' : 'text-orange']">Compliance</a>
		</div>

		<!-- #region efficiency -->
		<div v-if="tab == 'efficiency'" key="efficiency" class="flex-grow-1 mt-2">
			<div class="container-fluid px-2">
				<div class="row no-gutters reports">
					<div class="col-sm-6 align-items-center">
						<div class="border mr-1 mb-1 p-3 report-item">
							<h6 class="">Project Certainty Index</h6>
							<ProjectGauge :data="certainty_index"
								:fillBackground="$report.color(certainty_index.value)" />
						</div>
					</div>
					<div class="col-sm-6">
						<div class="border ml-1 mb-1 p-3 report-item">
							<h6 class="">Zone Time Breakdown</h6>
							<ProjectZoneTime :data="project_zone_time_data" />
						</div>
					</div>
				</div>
				<div class="row no-gutters mt-2 reports">
					<div class="col-sm-6">
						<div class="border mr-1 mt-1 p-3 report-item mini-charts">
							<div class="row no-gutters">
								<div class="col-sm-4">
									<h6 class="">Checkup</h6>
								</div>
								<div class="col-sm-5 small text-center text-muted">Project Trend</div>
								<div class="col-sm-3 small text-muted text-nowrap">Current Week
									({{ moment(week.start).format('M/D') }} - {{ moment(week.end).format('M/D') }})
								</div>
							</div>
							<div class="row no-gutters border p-1 mb-3">
								<div class="col-sm-4 text-right pr-5 align-self-center">Safety Certainty Index</div>
								<div class="col-sm-5 chart-item">
									<transition name="fade">
										<ProjectHistoryGauge :data="safety_index" v-if="safety_index.length" />
										<div class="mini-graph" v-else></div>
									</transition>
									<small class="empty-text" v-if="safety_index.length === 0">
										{{ empty_text }}
									</small>
								</div>
								<div class="col-sm-3 chart-item">
									<ProjectIndexGauge :data="safety_index_week" :centered="true"
										:fillBackground="$report.color(safety_index_week.value)" />
								</div>
							</div>
							<div class="row no-gutters border p-1 mb-3">
								<div class="col-sm-4 text-right pr-5 align-self-center">First Starts</div>
								<div class="col-sm-5 chart-item">
									<transition name="fade">
										<ProjectHistoryGauge :data="first_start_index"
											v-if="first_start_index.length" />
										<div class="mini-graph" v-else></div>
									</transition>
									<small class="empty-text" v-if="first_start_index.length === 0">
										{{ empty_text }}
									</small>
								</div>
								<div class="col-sm-3 chart-item">
									<ProjectIndexGauge :data="first_start_index_week" :centered="true"
										:fillBackground="$report.color(first_start_index_week.value)" />
								</div>
							</div>
							<div class="row no-gutters border p-1 mb-3">
								<div class="col-sm-4 text-right pr-5 align-self-center">Mustering Efficiency</div>
								<div class="col-sm-5 chart-item">
									<transition name="fade">
										<ProjectHistoryGauge :data="mustering_efficiency"
											v-if="mustering_efficiency.length" />
										<div class="mini-graph" v-else></div>
									</transition>
									<small class="empty-text" v-if="mustering_efficiency.length === 0">
										{{ empty_text }}
									</small>
								</div>
								<div class="col-sm-3 chart-item">
									<ProjectIndexGauge :data="mustering_efficiency_week" :centered="true"
										:fillBackground="$report.color(mustering_efficiency_week.value)" />
								</div>
							</div>
							<div class="row no-gutters border p-1 mb-3">
								<div class="col-sm-4 text-right pr-5 align-self-center">Time in Work Zone</div>
								<div class="col-sm-5 chart-item">
									<transition name="fade">
										<ProjectHistoryGauge :data="time_in_work_zone_index"
											v-if="time_in_work_zone_index.length" />
										<div class="mini-graph" v-else></div>
									</transition>
									<small class="empty-text" v-if="time_in_work_zone_index.length === 0">
										{{ empty_text }}
									</small>
								</div>
								<div class="col-sm-3 chart-item">
									<ProjectIndexGauge :data="time_in_work_zone_index_week" :centered="true"
										:fillBackground="$report.color(time_in_work_zone_index_week.value)" />
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="border ml-1 mt-1 p-3 report-item clearfix icon-box">
							<h6 class="">Reports</h6>
							<a v-b-modal="'mustering-report-modal'" href="#" @click.prevent="" class="border">
								<img class="img-fluid mr-3" src="~/assets/img/icons/muster-icon.png"
									alt="Mustering Report">
								Emergency Mustering Report
							</a>
							<a v-b-modal="'fall-report-modal'" href="#" class="border">
								<img class="img-fluid mr-3" src="~/assets/img/icons/fall-icon.png"
									alt="Mustering Report">
								Fall / Man Down Report
							</a>
							<a v-b-modal="'zone-violation-report-modal'" href="#" class="border">
								<img class="img-fluid mr-3" src="~/assets/img/icons/restricted-zone-violation-icon.png"
									alt="Mustering Report">
								Critical Zone Violation Report
							</a>
							<a v-b-modal="'work-zone-report-modal'" href="#" class="border">
								<img class="img-fluid mr-3" src="~/assets/img/icons/work-icon.png"
									alt="Mustering Report">
								Work Zone Summaries
							</a>
						</div>
					</div>
				</div>
			</div>
			<MusteringReport />
			<ZoneViolationReport />
			<FallReport />
			<WorkZoneReport />
		</div>
		<!-- #endregion -->


		<!-- #region compliance -->
		<div v-else key="compliance" class="flex-grow-1 mt-2">
			<div class="container-fluid px-2">
				<div class="row no-gutters reports">
					<div class="col-sm-4 align-items-center">
						<div class="border mb-1 p-3 report-item">
							<div class="d-flex align-items-center mb-4">
								<h6 class="flex-grow-1 text-nowrap pr-5 text-primary">Apprentice Labor Ratio</h6>
								<b-form-select style="width: 120px" class="flex-shrink-1" v-model="selected_date"  :options="Object.keys(apprentice_rates)"></b-form-select>
							</div>
							<ProjectGauge :data="apprentice_rates[selected_date]"
								:fillBackground="$report.color(apprentice_rates[selected_date].value, 'compliance_colors')" />
						</div>
					</div>
					<div class="col-sm-5">
						<div class="border ml-1 mb-1 p-3 report-item">
							<div class="d-flex align-items-center mb-4">
								<h6 class="flex-grow-1 text-nowrap text-primary">Workforce Allocation</h6>
								<b-form-select class="flex-shrink-1" style="width: 170px" v-model="selected_week"  :options="week_options"></b-form-select>
							</div>
							<ApprenticeRateWeekly :data="weekly_apprentice_rates[selected_week]" :maxY="Object.keys(workers).length" />
						</div>
					</div>

					<div class="col-sm-3">
						<div class="border ml-1 mb-1 p-3 report-item d-flex flex-column">
							<h6 class="text-primary">Workforce Schedules</h6>
							<div class="flex-grow-1">
								<table class="table table-sm">
									<tr class="text-primary font-sm">
										<td style="width: 80px;">Timesheets Through</td>
										<td>Company Name</td>
									</tr>
									<tr v-for="company in companies" :key="company.id">
										<td class="text-muted">{{ moment().add(faker.datatype.number({min: 1, max: 15}), 'days').format("MM/DD") }}</td>
										<td class="text-primary">{{ company.title }}</td>
									</tr>
								</table>
							</div>
							<a href="#" class="text-primary d-block m-auto" @click.prevent>Upload Timesheet Schedule</a>
						</div>
					</div>
				</div>


				<div class="row no-gutters mt-2">
					<div class="col align-items-center">
						<div class="border mb-1 p-3">
							<h6>Reports</h6>
							<div class="d-flex flex-wrap" style="gap: 0.5rem">
								<div style="width: 355px">
									<a v-b-modal="'payroll-form-modal'" href="#" @click.prevent="" class="border p-3 d-flex align-items-center">
										<img class="img-fluid mr-3"
											src="~/assets/img/icons/whd-icon.png"
											style="height: 30px;"
										>
										<span>Weekly Payroll Form WH347</span>
									</a>
								</div>

								<div style="width: 355px">
									<a v-b-modal="'apprentice-ratio-modal'" href="#" @click.prevent="" class="border p-1 d-flex align-items-center">
										<img class="img-fluid mr-3"
											src="~/assets/img/icons/apprentice-ratio.png"
										>
										<span>Apprentice Ratio Report</span>
									</a>
								</div>

								<div style="width: 355px">
									<a v-b-modal="'workforce-planning-modal'" href="#" @click.prevent="" class="border p-1 d-flex align-items-center">
										<img class="img-fluid mr-3"
											src="~/assets/img/icons/workforce-planning.png"
										>
										<span>Workforce Planning Report</span>
									</a>
								</div>

								<div style="width: 355px">
									<a v-b-modal="'prevailing-wage-modal'" href="#" @click.prevent="" class="border p-1 d-flex align-items-center">
										<img class="img-fluid mr-3"
											src="~/assets/img/icons/prevailing-wage.png"
										>
										<span>Prevailing Wage Report</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			
			<PayrollForm></PayrollForm>
			<ApprenticeRatio></ApprenticeRatio>
			<WorkforcePlanning></WorkforcePlanning>
			<PrevailingWage></PrevailingWage>
			

		</div>
		<!-- #endregion -->
	</div>


</template>


<script>

import ApprenticeRateWeekly from '../../components/Views/Reports/ApprenticeRateWeekly';
import ProjectGauge from '../../components/Views/Reports/ProjectGauge';
import ProjectHistoryGauge from '../../components/Views/Reports/ProjectHistoryGauge';
import ProjectZoneTime from '../../components/Views/Reports/ProjectZoneTime';
import MusteringReport from '../../components/Views/Reports/MusteringReport';
import ZoneViolationReport from '../../components/Views/Reports/ZoneViolationReport';
import FallReport from '../../components/Views/Reports/FallReport.vue';
import WorkZoneReport from '../../components/Views/Reports/WorkZoneReport.vue';
import ProjectIndexGauge from '../../components/Views/Reports/ProjectIndexGauge';
import PayrollForm from '../../components/Views/Reports/PayrollForm';
import ApprenticeRatio from '../../components/Views/Reports/ApprenticeRatio';
import WorkforcePlanning from '../../components/Views/Reports/WorkforcePlanning';
import PrevailingWage from '../../components/Views/Reports/PrevailingWage';

import { mapState } from 'vuex';
import faker from 'faker';


export default {
	name: 'Project',
	data() {
		return {
			empty_text: 'Not enough data available to accurately produce graph. At least full day of records are necessary.',
			tab: 'efficiency',
			selected_date: this.$datetime.date(),
			selected_week: 0,
			faker: faker,
		}
	},
	computed: {
		...mapState(['companies']),
		workers() { return this.$store.state.workers },
		log() { return this.$store.state.log },
		watcher() {
			return this.$store.state.watcher
		},
		alert() {
			return this.$store.state.alert
		},
		time() {
			return this.$store.state.time
		},
		start_time() {
			return this.$config.start_time
		},
		end_time() {
			return this.$config.end_time
		},
		extended() {
			return this.$store.state.bottom_menu_collapsed
		},
		day() { return this.$store.state.day },
		start_date() { return this.$store.state.start_date },
		week() {
			let end = this.moment(this.start_date).add(this.day - 1, 'days');
			let start = this.moment(end).subtract(7, 'days').format();

			start = this.moment.max(this.moment(start), this.moment(this.start_date));

			return { start: start, end: end }
		},
		week_range() {
			return [this.day - 6, this.day];
		},
		safety_index() {
			return this.$store.state.report.safety;
		},
		safety_index_week() {
			return { value: this.$finder.avg(this.safety_index.slice(this.week_range)) };
		},
		mustering_efficiency() {
			return this.$store.state.report.mustering;
		},
		mustering_efficiency_week() {
			return { value: this.$finder.avg(this.mustering_efficiency.slice(this.week_range)) };
		},
		time_in_work_zone_index() {
			return this.$store.state.report.time_in_work_zone || [];
		},
		time_in_work_zone_index_week() {
			return { value: this.$finder.avg(this.time_in_work_zone_index.slice(this.week_range)) };
		},
		first_start_index() {
			return this.$store.state.report.first_starts;
		},
		first_start_index_week() {
			return { value: this.$finder.avg(this.first_start_index.slice(this.week_range)) };
		},
		certainty_index() {
			return this.$store.state.report.certainty_index;
		},
		project_zone_time_data() {
			return this.$store.state.report.project_zone_time;
		},
		apprentice_rates() {
			return this.$store.state.report.apprentice_rates;
		},
		weekly_apprentice_rates() {
			const weekly_rates = [];
			const chunks = this.$finder.chunk(Object.keys(this.apprentice_rates), 7);
			for (let week_index in chunks) {
				const dates = chunks[week_index];
				weekly_rates[week_index] = {};
				for (let date of dates) {
					weekly_rates[week_index][date] = this.apprentice_rates[date];
				}

			}

			return weekly_rates;
		},
		week_options() {
			return this.weekly_apprentice_rates.map((rate, index) => {
				const key = `${Object.keys(rate)[0]} - ${Object.keys(rate)[6]}`;
				return { value: index, text: key }
			});
		}
	},
	components: {
		ApprenticeRateWeekly,
		ApprenticeRatio,
		ProjectZoneTime,
		ProjectGauge,
		ProjectHistoryGauge,
		MusteringReport,
		ZoneViolationReport,
		FallReport,
		WorkZoneReport,
		ProjectIndexGauge,
		PayrollForm,
		WorkforcePlanning,
		PrevailingWage,
	}
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.reports {
	.report-item {
		min-height: 330px;
		height: 100%;
	}
}

.icon-box {
	a {
		width: 300px;
		text-decoration: none;
		height: 40px;
		display: inline-block;
		padding: 5px;
		margin-right: 5px;
		margin-bottom: 5px;

		img {
			max-height: 100%;
		}
	}
}

.chart-item {
	height: 64px;
	position: relative;
}

.empty-text {
	line-height: 1.4;
	display: none;
	margin-top: 5px;
	padding-right: 20px;
}

.mini-graph {
	width: 87px;
	height: 40px;
	background: #ccc;
	position: absolute;
	top: 0;

	&.centered {
		left: 50%;
		margin-left: -43.5px;
	}
}
</style>

